import { Directive, TemplateRef, ViewContainerRef, Input, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
    selector: '[ycIfSystemRole]',
    standalone: false
})
export class IfSystemRoleDirective implements OnInit {
  @Input() ycIfSystemRole: string;
  constructor (
    public templateRef: TemplateRef<any>,
    public viewRef: ViewContainerRef,
    public roleService: AuthService
  ) {
  }

  ngOnInit () {
    if (this.roleService.hasSystemRole(this.ycIfSystemRole)) {
      this.viewRef.createEmbeddedView(this.templateRef, {}, 0);
    }
  }
}
